function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_c('em',[_vm._v("Welcome")])]),_vm._v(" "),_c('p',[_vm._v("You need to register to continue.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/login/index","lang":"en","errors":{"auth/invalid-email":"Error! Invalid email address.","auth/email-already-exists":"Error! There is a registered user with this email address.","auth/wrong-password":"Error! Wrong password.","auth/user-not-found":"Error! Unknown email address.","auth/network-request-failed":"Error! Can't connect to server."}},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }